import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 1px;\n  background-color: ", ";\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import CardBody from './CardBody';
var Divider = styled.div(_templateObject(), function (p) {
  return p.theme[p.brand];
});

var CardDivider = function CardDivider(_ref) {
  var backgroundBrand = _ref.backgroundBrand,
      _ref$brand = _ref.brand,
      brand = _ref$brand === void 0 ? 'grey5' : _ref$brand;
  return /*#__PURE__*/React.createElement(CardBody, {
    brand: backgroundBrand
  }, /*#__PURE__*/React.createElement(Divider, {
    brand: brand
  }));
};

export default CardDivider;